import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  bottom: 15px;
  right: 15px;
`;
